import { render, staticRenderFns } from "./PlaySport.vue?vue&type=template&id=02b90ec3&scoped=true&"
import script from "./PlaySport.vue?vue&type=script&lang=js&"
export * from "./PlaySport.vue?vue&type=script&lang=js&"
import style0 from "./PlaySport.vue?vue&type=style&index=0&id=02b90ec3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b90ec3",
  null
  
)

export default component.exports